export class InternalError extends Error {
    constructor(message) {
        super(message);
        this.name = 'InternalError';
    }
}
//# sourceMappingURL=internal_error.js.map